import { Icon20UnlockOutline } from '@vkontakte/icons';
import React, { memo } from 'react';
import {
    type SharingOptionDomainProps,
    SharingOptionDomain,
} from 'reactApp/components/SharingWindow/blocks/SharingOptions/SharingOptionDomain';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

import styles from './SharingBizDisabledWeblinkBlock.css';

interface Props extends SharingOptionDomainProps {
    isPublic?: boolean;
    onOpenAccessClick: () => void;
    isPhone?: boolean;
}

export const SharingBizDisabledWeblinkBlock = memo(({ isPublic, onOpenAccessClick, isPhone, ...optionDomainProps }: Props) => {
    return (
        <div className={styles.sharingDisabledBlockContainer} data-qa-id="sharing-biz-disabled-block">
            <div className={styles.sharingDisabledOptions}>
                <SharingOptionDomain {...optionDomainProps} />
            </div>
            {!isPublic && (
                <Button
                    qaId="sharing-biz-disabled-block-enable-button"
                    className={styles.sharingDisabledOpenAccessButton}
                    theme={'base'}
                    middle
                    onClick={onOpenAccessClick}
                    sizeMode={isPhone ? ButtonSizeMode.big : ButtonSizeMode.middle}
                >
                    <Icon20UnlockOutline width={20} height={20} />
                    <span>Открыть доступ</span>
                </Button>
            )}
        </div>
    );
});

SharingBizDisabledWeblinkBlock.displayName = 'SharingBizDisabledWeblinkBlock';
